import actions from './actions';


const { 
    OUTDOOR_INFO_DATA_BEGIN, OUTDOOR_INFO_DATA_SUCCESS, OUTDOOR_INFO_DATA_ERR, 
    OUTDOOR_INFO_PPT_DETAILS_DATA_BEGIN, OUTDOOR_INFO_PPT_DETAILS_DATA_SUCCESS, OUTDOOR_INFO_PPT_DETAILS_DATA_ERR, OUTDOOR_INFO_PPT_DETAILS_DATA_RESET,
    OUTDOOR_INFO_PPT_LIST_DATA_BEGIN, OUTDOOR_INFO_PPT_LIST_DATA_SUCCESS, OUTDOOR_INFO_PPT_LIST_DATA_ERR, OUTDOOR_INFO_PPT_LIST_DATA_RESET,
    OUTDOOR_CUSTOMER_INFO_DATA_BEGIN, OUTDOOR_CUSTOMER_INFO_DATA_SUCCESS, OUTDOOR_CUSTOMER_INFO_DATA_ERR, OUTDOOR_CUSTOMER_INFO_DATA_RESET,
    OUTDOOR_FBO_DETAILS_DATA_BEGIN, OUTDOOR_FBO_DETAILS_DATA_SUCCESS, OUTDOOR_FBO_DETAILS_DATA_ERR, OUTDOOR_FBO_DETAILS_DATA_RESET,
    SUBMIT_PPT_INFO_DATA_BEGIN,SUBMIT_PPT_INFO_DATA_SUCCESS, SUBMIT_PPT_INFO_DATA_ERR, SUBMIT_PPT_INFO_DATA_RESET,
    OUTDOOR_HISTORY_DETAILS_BEGIN,OUTDOOR_HISTORY_DETAILS_SUCCESS, OUTDOOR_HISTORY_DETAILS_ERR,
    OUTDOOR_GET_EXCHANGE_DATA_BEGIN, OUTDOOR_GET_EXCHANGE_DATA_SUCCESS, OUTDOOR_GET_EXCHANGE_DATA_ERR, OUTDOOR_GET_EXCHANGE_DATA_RESET,
    SUBMIT_MISSING_PPT_INFO_DATA_BEGIN,SUBMIT_MISSING_PPT_INFO_DATA_SUCCESS, SUBMIT_MISSING_PPT_INFO_DATA_ERR, SUBMIT_MISSING_PPT_INFO_DATA_RESET,
    OUTDOOR_START_TOKEN_BEGIN, OUTDOOR_START_TOKEN_SUCCESS, OUTDOOR_START_TOKEN_ERR, OUTDOOR_START_TOKEN_RESET,
    OUTDOOR_EXCHNAGE_PRICE_BEGIN,OUTDOOR_EXCHNAGE_PRICE_SUCCESS,OUTDOOR_EXCHNAGE_PRICE_ERR,OUTDOOR_EXCHNAGE_PRICE_RESET,
} = actions;

const initialStateArray = { data: [], loading: false, error: null, };

// Outdoor Information Data Reducers
export const outdoorInfoDataReducers = (state = initialStateArray, action) => {
    const { type, data, err } = action;
    switch (type) {
        case OUTDOOR_INFO_DATA_BEGIN:
            return {
                ...initialStateArray,
                loading: true,
            };
        case OUTDOOR_INFO_DATA_SUCCESS:
            return {
                ...initialStateArray,
                data,
                error:null,
                loading: false,
            };
        case OUTDOOR_INFO_DATA_ERR:
            return {
                ...initialStateArray,
                error: err,
                data:null,
                loading: false,
            };

        default:
            return state;
    }
};

// Outdoor PPT List Data Reducers
export const outdoorInfoPPTListDataReducers = (state = initialStateArray, action) => {
    const { type, data, err } = action;
    switch (type) {
        case OUTDOOR_INFO_PPT_LIST_DATA_BEGIN:
            return {
                ...initialStateArray,
                loading: true,
            };
        case OUTDOOR_INFO_PPT_LIST_DATA_SUCCESS:
            return {
                ...initialStateArray,
                data,
                error:null,
                loading: false,
            };
        case OUTDOOR_INFO_PPT_LIST_DATA_ERR:
            return {
                ...initialStateArray,
                error: err,
                data:null,
                loading: false,
            };
        case OUTDOOR_INFO_PPT_LIST_DATA_RESET:
            return initialStateArray;

        default:
            return state;
    }
};

// Outdoor Details Data Reducers
export const outdoorInfoPPTDetailsDataReducers = (state = initialStateArray, action) => {
    const { type, data, err } = action;
    switch (type) {
        case OUTDOOR_INFO_PPT_DETAILS_DATA_BEGIN:
            return {
                ...initialStateArray,
                loading: true,
            };
        case OUTDOOR_INFO_PPT_DETAILS_DATA_SUCCESS:
            return {
                ...initialStateArray,
                data,
                error:null,
                loading: false,
            };
        case OUTDOOR_INFO_PPT_DETAILS_DATA_ERR:
            return {
                ...initialStateArray,
                error: err,
                data:null,
                loading: false,
            };
        case OUTDOOR_INFO_PPT_DETAILS_DATA_RESET:
            return initialStateArray;

        default:
            return state;
    }
};

// Outdoor Customer Info
export const outdoorCustomerInfoDataReducers = (state = initialStateArray, action) => {
    const { type, data, err } = action;
    switch (type) {
        case OUTDOOR_CUSTOMER_INFO_DATA_BEGIN:
            return {
                ...state,
                loading: true,
            };
        case OUTDOOR_CUSTOMER_INFO_DATA_SUCCESS:
            return {
                ...initialStateArray,
                data,
                error:null,
                loading: false,
            };
        case OUTDOOR_CUSTOMER_INFO_DATA_ERR:
            return {
                ...initialStateArray,
                error: err,
                data:null,
                loading: false,
            };
        case OUTDOOR_CUSTOMER_INFO_DATA_RESET:
            return initialStateArray;

        default:
            return state;
    }
}

export const submitaOutdoorFBODataReducers = (state = initialStateArray, action) => {
    const { type, data, err } = action;
    switch (type) {
        case OUTDOOR_FBO_DETAILS_DATA_BEGIN:
            return {
                ...initialStateArray,
                loading: true,
            };
        case OUTDOOR_FBO_DETAILS_DATA_SUCCESS:
            return {
                ...initialStateArray,
                data,
                error:null,
                loading: false,
            };
        case OUTDOOR_FBO_DETAILS_DATA_ERR:
            return {
                ...initialStateArray,
                error: err,
                data:null,
                loading: false,
            };
        case OUTDOOR_FBO_DETAILS_DATA_RESET:
            return initialStateArray;

        default:
            return state;
    }
}


// Outdoor PP Info Submit Date Reducers
export const submitOutdoorPPTInfoDataReducers = (state = initialStateArray, action) => {
    const { type, data, err } = action;
    switch (type) {
        case SUBMIT_PPT_INFO_DATA_BEGIN:
            return {
                ...initialStateArray,
                loading: true,
            };
        case SUBMIT_PPT_INFO_DATA_SUCCESS:
            return {
                ...initialStateArray,
                data,
                error:null,
                loading: false,
            };
        case SUBMIT_PPT_INFO_DATA_ERR:
            return {
                ...initialStateArray,
                error: err,
                data:null,
                loading: false,
            };
        case SUBMIT_PPT_INFO_DATA_RESET:
            return initialStateArray;

        default:
            return state;
    }
}



export const getExchangeDataReducers = (state = initialStateArray, action) => {
    const { type, data, err } = action;
    switch (type) {
        case OUTDOOR_GET_EXCHANGE_DATA_BEGIN:
            return {
                ...initialStateArray,
                loading: true,
            };
        case OUTDOOR_GET_EXCHANGE_DATA_SUCCESS:
            return {
                ...initialStateArray,
                data,
                error:null,
                loading: false,
            };
        case OUTDOOR_GET_EXCHANGE_DATA_ERR:
            return {
                ...initialStateArray,
                error: err,
                data:null,
                loading: false,
            };
        case OUTDOOR_GET_EXCHANGE_DATA_RESET:
            return initialStateArray;

        default:
            return state;
    }
}

export const submitOutdoorMissingPPTInfoDataReducers = (state = initialStateArray, action) => {
    const { type, data, err } = action;
    switch (type) {
        case SUBMIT_MISSING_PPT_INFO_DATA_BEGIN:
            return {
                ...initialStateArray,
                loading: true,
            };
        case SUBMIT_MISSING_PPT_INFO_DATA_SUCCESS:
            return {
                ...initialStateArray,
                data,
                error:null,
                loading: false,
            };
        case SUBMIT_MISSING_PPT_INFO_DATA_ERR:
            return {
                ...initialStateArray,
                error: err,
                data:null,
                loading: false,
            };
        case SUBMIT_MISSING_PPT_INFO_DATA_RESET:
            return initialStateArray;

        default:
            return state;
    }
}


export const OutdoorHistoryDataReducers = (state = initialStateArray, action) => {
    const { type, data, err } = action;
    switch (type) {
        case OUTDOOR_HISTORY_DETAILS_BEGIN:
            return {
                ...initialStateArray,
                loading: true,
            };
        case OUTDOOR_HISTORY_DETAILS_SUCCESS:
            return {
                ...initialStateArray,
                data,
                error:null,
                loading: false,
            };
        case OUTDOOR_HISTORY_DETAILS_ERR:
            return {
                ...initialStateArray,
                error: err,
                data:null,
                loading: false,
            };
        default:
            return state;
    }
}

export const OutdoorViewDetailsReducer = (state=initialStateArray,action)=>{
    const { type, data, err } = action
    switch (type) {
      case "OUTDOOR_VIEW_DETAILS_BEGIN":
        return{
          ...state,
          loading:true
        };
        case "OUTDOOR_VIEW_DETAILS_SUCCESS":
          return{
            ...state,
            data,
            error:null,
            loading:false
          }
        case "OUTDOOR_VIEW-DETAILS_ERR":
          return{
            ...state,
            error:err,
            data:null,
            loading:false,
          }
        default:
          return state
    }
}


export const OutdoorFBOHistoryDataReducers = (state = initialStateArray, action) => {
    const { type, data, err } = action;
    switch (type) {
        case "OUTDOOR_FBO_HISTORY_DETAILS_BEGIN":
            return {
                ...initialStateArray,
                loading: true,
            };
        case "OUTDOOR_FBO_HISTORY_DETAILS_SUCCESS":
            return {
                ...initialStateArray,
                data,
                error:null,
                loading: false,
            };
        case "OUTDOOR_FBO_HISTORY_DETAILS_ERR":
            return {
                ...initialStateArray,
                error: err,
                data:null,
                loading: false,
            };
        default:
            return state;
    }
}

export const OutdoorFBOViewDetailsReducer = (state=initialStateArray,action)=>{
    const { type, data, err } = action
    switch (type) {
      case "OUTDOOR_FBO_VIEW_DETAILS_BEGIN":
        return{
          ...state,
          loading:true
        };
        case "OUTDOOR_FBO_VIEW_DETAILS_SUCCESS":
          return{
            ...state,
            data,
            error:null,
            loading:false
          }
        case "OUTDOOR_FBO_VIEW-DETAILS_ERR":
          return{
            ...state,
            error:err,
            data:null,
            loading:false,
          }
        default:
          return state
    }
}

export const postStartTokenDataReducers = (state = initialStateArray, action) => {
    const { type, data, err } = action;
    switch (type) {
        case OUTDOOR_START_TOKEN_BEGIN:
            return {
                ...initialStateArray,
                loading: true,
            };
        case OUTDOOR_START_TOKEN_SUCCESS:
            return {
                ...initialStateArray,
                data,
                error:null,
                loading: false,
            };
        case OUTDOOR_START_TOKEN_ERR:
            return {
                ...initialStateArray,
                error: err,
                data:null,
                loading: false,
            };
        case OUTDOOR_START_TOKEN_RESET:
            return initialStateArray;

        default:
            return state;
    }
}

export const postExchnagePricenDataReducers = (state = initialStateArray, action) => {
    const { type, data, err } = action;
    switch (type) {
        case OUTDOOR_EXCHNAGE_PRICE_BEGIN:
            return {
                ...initialStateArray,
                loading: true,
            };
        case OUTDOOR_EXCHNAGE_PRICE_SUCCESS:
            return {
                ...initialStateArray,
                data,
                error:null,
                loading: false,
            };
        case OUTDOOR_EXCHNAGE_PRICE_ERR:
            return {
                ...initialStateArray,
                error: err,
                data:null,
                loading: false,
            };
        case OUTDOOR_EXCHNAGE_PRICE_RESET:
            return initialStateArray;

        default:
            return state;
    }
}
